import _ from 'lodash';
/**
 * コンサル用のマスタの絞り込み
 * @param v
 * @returns {boolean}
 */
export const relationFilterByNormal = (v) => v.type === 1;
/**
 * フリーコンサル用のマスタの絞り込み
 * @param v
 * @returns {boolean}
 */
export const relationFilterByFree = (v) => v.type === 2;
/**
 * dateでソート
 * @param obj
 * @param key
 * @returns {unknown[]}
 */
export const sortByDate = (obj, key) => {
    const values = _.get(obj, key) || [];
    return _.sortBy(_.shuffle(values), ['date', 'id']).reverse();
};
